import { render, staticRenderFns } from "./notSupport.vue?vue&type=template&id=fd1ecd5e&scoped=true"
import script from "./notSupport.vue?vue&type=script&lang=js"
export * from "./notSupport.vue?vue&type=script&lang=js"
import style0 from "./notSupport.vue?vue&type=style&index=0&id=fd1ecd5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1ecd5e",
  null
  
)

export default component.exports